import { z } from '../zod.js';

export const EVENT_STAFF_MEMBERSHIP_STATUS = ['pending', 'active', 'revoked', 'deleted'] as const;

export const EventStaffMembershipStatusValidationEnum = z.enum(EVENT_STAFF_MEMBERSHIP_STATUS);

export type EventStaffMembershipStatus = (typeof EVENT_STAFF_MEMBERSHIP_STATUS)[number];

export const EVENT_STAFF_MEMBERSHIP_ROLE = ['scanner'] as const;

export const EventStaffMembershipRoleValidationEnum = z.enum(EVENT_STAFF_MEMBERSHIP_ROLE);

export type EventStaffMembershipRole = (typeof EVENT_STAFF_MEMBERSHIP_ROLE)[number];
